import { Spinner, Stack } from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { WeatherDisplay } from "../PlayerPreview";
import { formatWeatherApiData } from "../../utils/functions";
import { useFetch } from "../../hooks/useFetch";
import { weatherFetchUrl } from "../../utils/weatherQueries";
import { useWindowSize } from "react-use";
import { getWidgetWidth } from "@govisupro/controls";
export const PlayerDevice = ({ layoutItem }) => {
    var _a, _b, _c;
    const [weather, setWeather] = useState();
    const weatherRef = useRef(null);
    const widgetRefWidth = (_a = weatherRef === null || weatherRef === void 0 ? void 0 : weatherRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width;
    const { width } = useWindowSize();
    const weatherData = layoutItem.widget.data;
    const widgetWidth = getWidgetWidth({
        layoutItemWidth: layoutItem.width,
        widgetRefWidth: widgetRefWidth
            ? widgetRefWidth / ((_b = layoutItem.scale) !== null && _b !== void 0 ? _b : 1)
            : undefined,
        windowSize: width,
        screenWidth: undefined,
        scale: (_c = layoutItem.scale) !== null && _c !== void 0 ? _c : 1,
    });
    const fetchUrl = weatherFetchUrl({
        selectedCity: weatherData.city,
        weatherType: weatherData.type,
    });
    const { data, loading } = useFetch(fetchUrl);
    useEffect(() => {
        if (data === undefined)
            return;
        setWeather(formatWeatherApiData(data, weatherData.type));
    }, [data]);
    return (React.createElement(Stack, { ref: weatherRef }, weather && !loading ? (React.createElement(WeatherDisplay, { weatherData: weatherData, widgetWidth: widgetWidth !== null && widgetWidth !== void 0 ? widgetWidth : 0, weather: weather })) : (React.createElement(Spinner, null))));
};
